module.exports = __webpack_public_path__ + "static/4-2-x-7163594dbee79b66ed59a5ed1bb7f5ae.png";